import './App.css';
import { Route, Routes } from "react-router-dom";

 
import BuySell from './BuySell';
import Accounts from './Accounts/Accounts';
import RecipientAccount from './Recipient/RecipientAccount';
import FrontView from './FrontView';
import Dashboard from './Dashboard/Dashboard';
import VerificationModal from './Components/VerificationModal';
import AccountsForm from './Accounts/AccountsForm';
import TransactionCompleted from './Components/TransactionCompleted';
import ReceiveBtc from './Components/ReceiveBtc';
import Modal from './Components/Modal'
import Rejection from './Components/Rejection';
import TransactionRejected from './Recipient/TransactionRejected';
import Pending from './Components/Pending';
import ReceivedTransaction from './ReceivedTx/ReceivedTransaction'
import SendDio from './Accounts/SendDio';
import Sent from "./Components/Sent"



function App() {
  return (
    
      <Routes>
        <Route exact path='/' element={<FrontView/>} >
        <Route index path='/' element={<Dashboard />}/>
        <Route exact path='/buyselllegacy' element={<BuySell />} />
        <Route exact path='/accounts' element={<Accounts />} />
        <Route exact path='/recipientaccount' element={<RecipientAccount />} />
        <Route exact path='/verify' element={<VerificationModal/>} />
        <Route exact path='/form' element={<AccountsForm/>} />
        <Route exact path='/completed' element={<TransactionCompleted/>} />
        <Route exact path='/receivebtc' element={<ReceiveBtc/>} />
        <Route exact path='/modal' element={<Modal/>} />
        <Route exact path='/rejection' element={<Rejection/>}/>
        <Route exact path='/rejected' element={<TransactionRejected/>}/>
        <Route exact path='/pending' element={<Pending/>}/>
        <Route exact path='/receivedtx' element={<ReceivedTransaction/>}/>
        <Route exact path='/senddio' element ={<SendDio/>}/>
        <Route exact path='/sent' element={<Sent/>}/>
        
        
        </Route>
      </Routes>

    
  );
}

export default App;
